import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/da'
import kind from 'kind-of'
import DateTime from 'client/components/DateTime'
import actions from 'client/actions'
import CustomerInformation from 'client/routes/Customer/CustomerInformation';
import { map, uniqBy, merge, forEach, reduce } from 'lodash'
import numeral from 'common/lib/numeral'
import classNames from 'classnames'
import DocumentTitle from 'react-document-title'
import ReactTooltip from 'react-tooltip'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {styles} from 'common/lib/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from 'client/components/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Contact from 'client/components/Contact';
import { PlanFileSchema } from 'common/schemas';
import { Condition } from 'client/components/Condition';
import { Chip } from '@material-ui/core';

class Dashboard extends Component {

  static propTypes = {
    readonly: PropTypes.bool.isRequired,
    plan: PropTypes.object.isRequired,
    texts: PropTypes.object.isRequired,
    notes: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    saveCustomerData: PropTypes.func.isRequired,
    route: PropTypes.object.isRequired,
  }

  constructor (props) {
    super(props)
    this.toggleView = this.toggleView.bind(this)
    this.handleBasisDialog = this.handleBasisDialog.bind(this)
    this.handleGuidanceDialog = this.handleGuidanceDialog.bind(this)
    this.state = {
      isEditing: false,
      isBasisDialogOpen: false,
      isGuidanceDialogOpen: false,
    }
  }

  componentDidMount() {
      const { dispatch, setBreadcrumb } = this.props
      dispatch(setBreadcrumb('Start'));
  }

  toggleView () {
    this.setState({
      isEditing: !this.state.isEditing,
    })
  }

  handleBasisDialog (e) {
    e.preventDefault()
    this.setState({
      isBasisDialogOpen: !this.state.isBasisDialogOpen
    })
  }

  handleGuidanceDialog (e) {
    e.preventDefault()
    this.setState({
      isGuidanceDialogOpen: !this.state.isGuidanceDialogOpen
    })
  }

  render () {
    const {
      plan, notes, texts,
      saveCustomerData, params: { customer_id },
      dispatch, route, readonly, classes
    } = this.props

    const {isBasisDialogOpen, isGuidanceDialogOpen} = this.state
    const { internal_contact = {} } = plan
    const notesList = map(notes, (note, idx) => {
      return (
        <li>
          <Link key={ idx } to={ `/c/${customer_id}/parts/${note.part_id}` }>
            { note.count } { note.count > 1 ? 'noter' : 'note' } på { `"${note.part_name}"` }
            { note.attachments.length > 0 ? <span> <i className="fa fa-paperclip"></i> { note.attachments.length }</span> : null }
          </Link>
        </li>
      )
    })

    let notification_count = ''
    if (kind(plan.email_notifications) === 'string' && plan.email_notifications !== '') {
      notification_count = plan.email_notifications.split(',').length
    }

    return (
      <div>
        <DocumentTitle title={ route.title } />
        {/* <section id="project-image" className="coverbackground wrapper" style={ { backgroundImage: `url(https://ik.imagekit.io/aw3ddey5g/${plan.s3_image_id}?tr=w-200)` } }>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-md-offset-3 col-xs-8 col-xs-offset-2 text-center">
                <div className="project-header">
                  <h3>{ plan.name }</h3>
                  <Link to={ `/c/${customer_id}/overview` } className="btn btn-lg btn-primary page-scroll">Start her &raquo;</Link>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <Grid container spacing={3}>
            <Grid item sm={12} md={6}>
            <Paper className={`${classes.paper} ${classes.iframeHeight}`}>
                <Typography className={classes.header} variant="h5">{ plan.name }</Typography>
                <div className={classes.infoTableContainer}>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Adresse</Typography>
                        <Typography className={classes.blueText}>
                            {plan.address1} {plan.address2 ? plan.address2 : null} {plan.address3 ? plan.address3 : null} {plan.zip_code ?  ", " + plan.zip_code + " " + plan.city : null}
                        </Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Opført år</Typography>
                        <Typography className={classes.blueText}>{plan.erected}</Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Samlet bruttoareal (privat)</Typography>
                        <Typography className={classes.blueText}>{plan.residential_area ? numeral(plan.residential_area).format('0,0') : 0 } m<sup>2</sup></Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Samlet bruttoareal (erhverv):</Typography>
                        <Typography className={classes.blueText}>{plan.commercial_area ? numeral(plan.commercial_area).format('0,0') : 0 } m<sup>2</sup></Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Antal enheder (privat)</Typography>
                        <Typography className={classes.blueText}>{plan.residential_units}</Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Antal enheder (erhverv)</Typography>
                        <Typography className={classes.blueText}>{plan.commercial_units}</Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Ejendomsnummer</Typography>
                        <Typography className={classes.blueText}>{plan.bbr_no}</Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Matrikelnummer</Typography>
                        <Typography className={classes.blueText}>{plan.cadastral_no}</Typography>
                    </div>
                    {plan.asset_company && <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Ejendomsadministrationsselskab</Typography>
                        <Typography className={classes.blueText}>{plan.asset_company}</Typography>
                    </div>}
                    {plan.asset_manager && <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Administrator</Typography>
                        <Typography className={classes.blueText}>{plan.asset_manager}</Typography>
                    </div>}
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Planen er oprettet</Typography>
                        <Typography className={classes.blueText}><DateTime source={ plan.created_at ? plan.created_at : plan.created_at } format="DD-MM-YYYY" /></Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Planen er sidst opdateret</Typography>
                        <Typography className={classes.blueText}><DateTime source={ plan.overridden_updated_at ? plan.overridden_updated_at : plan.updated_at } format="DD-MM-YYYY" /></Typography>
                    </div>
                    {plan.condition && <div className={classes.infoTable}>
                        <Typography className={classes.greyText}>Ejendommens stand</Typography>
                        <Typography className={classes.blueText}><Condition condition={ plan.condition } hasText={ true } /></Typography>
                    </div>}
                </div>
            </Paper>
            </Grid>
            <Grid item sm={12} md={6}>
                <Paper className={classes.paperWithoutHeight}>
                    <Typography className={classes.header} variant="h5">Om ejendommen</Typography>
                    <Typography paragraph>
                        { plan.about }
                    </Typography>
                    <div className={classes.logoLinks}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15.625V14.7202C6.7452 14.6496 6.02743 14.4523 5.36768 14.1499L4.9165 14.9326C4.74394 15.2315 4.36144 15.3337 4.0625 15.1611C3.76368 14.9886 3.66107 14.6065 3.8335 14.3076L4.28516 13.5244C3.68209 13.0948 3.1541 12.5666 2.72461 11.9634L1.94287 12.416C1.64408 12.5887 1.26165 12.4867 1.08887 12.188C0.916125 11.8891 1.01854 11.5067 1.31738 11.334L2.09912 10.8813C1.79699 10.2219 1.60038 9.50435 1.52979 8.75H0.625C0.279822 8.75 0 8.47018 0 8.125C0 7.77982 0.279822 7.5 0.625 7.5H1.52979C1.60039 6.7455 1.79689 6.02771 2.09912 5.36816L1.31738 4.91602C1.01854 4.74327 0.916125 4.36086 1.08887 4.06201C1.26165 3.76328 1.64408 3.66127 1.94287 3.83398L2.72461 4.28613C3.15412 3.68301 3.6821 3.1547 4.28516 2.7251L3.8335 1.94238C3.66107 1.64349 3.76368 1.26143 4.0625 1.08887C4.36144 0.916321 4.74394 1.01847 4.9165 1.31738L5.36768 2.09961C6.0274 1.79722 6.74525 1.59992 7.5 1.5293V0.625C7.5 0.279822 7.77982 0 8.125 0C8.47018 0 8.75 0.279822 8.75 0.625V1.5293C9.50437 1.59989 10.2219 1.79699 10.8813 2.09912L11.334 1.31738C11.5067 1.01854 11.8891 0.916125 12.188 1.08887C12.4867 1.26165 12.5887 1.64408 12.416 1.94287L11.9634 2.72461C12.5669 3.15431 13.0951 3.6827 13.5249 4.28613L14.3071 3.83398C14.6059 3.66127 14.9883 3.76328 15.1611 4.06201C15.3339 4.36086 15.2315 4.74327 14.9326 4.91602L14.1504 5.36816C14.4527 6.02776 14.6496 6.74542 14.7202 7.5H15.625C15.9702 7.5 16.25 7.77982 16.25 8.125C16.25 8.47018 15.9702 8.75 15.625 8.75H14.7202C14.6496 9.50442 14.4526 10.2219 14.1504 10.8813L14.9326 11.334C15.2315 11.5067 15.3339 11.8891 15.1611 12.188C14.9883 12.4867 14.6059 12.5887 14.3071 12.416L13.5249 11.9634C13.0952 12.5669 12.5669 13.0952 11.9634 13.5249L12.416 14.3071C12.5887 14.6059 12.4867 14.9883 12.188 15.1611C11.8891 15.3339 11.5067 15.2315 11.334 14.9326L10.8813 14.1504C10.2219 14.4526 9.50442 14.6496 8.75 14.7202V15.625C8.75 15.9702 8.47018 16.25 8.125 16.25C7.77982 16.25 7.5 15.9702 7.5 15.625ZM10.1562 8.75C9.88933 9.61853 9.08106 10.25 8.125 10.25C7.96161 10.25 7.80271 10.2307 7.6499 10.1958L5.99658 13.061C6.64938 13.3429 7.36875 13.5 8.125 13.5C10.8821 13.5 13.1527 11.424 13.4624 8.75H10.1562ZM4.91357 3.81396C3.6002 4.79393 2.75 6.36031 2.75 8.125C2.75 9.88959 3.60033 11.4556 4.91357 12.4355L6.56738 9.56982C6.21549 9.19064 6 8.6831 6 8.125C6 7.56677 6.21535 7.0589 6.56738 6.67969L4.91357 3.81396ZM8.125 2.75C7.36882 2.75 6.64933 2.90666 5.99658 3.18848L7.6499 6.05371C7.80268 6.01881 7.96164 6 8.125 6C9.08106 6 9.88933 6.63147 10.1562 7.5H13.4624C13.1527 4.82601 10.8821 2.75 8.125 2.75ZM7.25 8.125C7.25 8.44547 7.42269 8.72501 7.67969 8.87744C7.68219 8.87884 7.68501 8.87991 7.6875 8.88135C7.69189 8.88388 7.69589 8.88702 7.7002 8.88965C7.82604 8.95971 7.97075 9 8.125 9C8.60825 9 9 8.60825 9 8.125C9 7.64175 8.60825 7.25 8.125 7.25C7.97388 7.25 7.83156 7.28803 7.70752 7.35547C7.70078 7.35971 7.69445 7.36464 7.6875 7.36865C7.68508 7.37005 7.68212 7.37071 7.67969 7.37207C7.42257 7.52447 7.25 7.80444 7.25 8.125Z" fill="#183649"/>
                        </svg>
                        <a href="#" onClick={this.handleGuidanceDialog}>
                            Læs vejledning her
                        </a>
                    </div>
                    <div className={classes.logoLinks}>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 15.625V14.7202C6.7452 14.6496 6.02743 14.4523 5.36768 14.1499L4.9165 14.9326C4.74394 15.2315 4.36144 15.3337 4.0625 15.1611C3.76368 14.9886 3.66107 14.6065 3.8335 14.3076L4.28516 13.5244C3.68209 13.0948 3.1541 12.5666 2.72461 11.9634L1.94287 12.416C1.64408 12.5887 1.26165 12.4867 1.08887 12.188C0.916125 11.8891 1.01854 11.5067 1.31738 11.334L2.09912 10.8813C1.79699 10.2219 1.60038 9.50435 1.52979 8.75H0.625C0.279822 8.75 0 8.47018 0 8.125C0 7.77982 0.279822 7.5 0.625 7.5H1.52979C1.60039 6.7455 1.79689 6.02771 2.09912 5.36816L1.31738 4.91602C1.01854 4.74327 0.916125 4.36086 1.08887 4.06201C1.26165 3.76328 1.64408 3.66127 1.94287 3.83398L2.72461 4.28613C3.15412 3.68301 3.6821 3.1547 4.28516 2.7251L3.8335 1.94238C3.66107 1.64349 3.76368 1.26143 4.0625 1.08887C4.36144 0.916321 4.74394 1.01847 4.9165 1.31738L5.36768 2.09961C6.0274 1.79722 6.74525 1.59992 7.5 1.5293V0.625C7.5 0.279822 7.77982 0 8.125 0C8.47018 0 8.75 0.279822 8.75 0.625V1.5293C9.50437 1.59989 10.2219 1.79699 10.8813 2.09912L11.334 1.31738C11.5067 1.01854 11.8891 0.916125 12.188 1.08887C12.4867 1.26165 12.5887 1.64408 12.416 1.94287L11.9634 2.72461C12.5669 3.15431 13.0951 3.6827 13.5249 4.28613L14.3071 3.83398C14.6059 3.66127 14.9883 3.76328 15.1611 4.06201C15.3339 4.36086 15.2315 4.74327 14.9326 4.91602L14.1504 5.36816C14.4527 6.02776 14.6496 6.74542 14.7202 7.5H15.625C15.9702 7.5 16.25 7.77982 16.25 8.125C16.25 8.47018 15.9702 8.75 15.625 8.75H14.7202C14.6496 9.50442 14.4526 10.2219 14.1504 10.8813L14.9326 11.334C15.2315 11.5067 15.3339 11.8891 15.1611 12.188C14.9883 12.4867 14.6059 12.5887 14.3071 12.416L13.5249 11.9634C13.0952 12.5669 12.5669 13.0952 11.9634 13.5249L12.416 14.3071C12.5887 14.6059 12.4867 14.9883 12.188 15.1611C11.8891 15.3339 11.5067 15.2315 11.334 14.9326L10.8813 14.1504C10.2219 14.4526 9.50442 14.6496 8.75 14.7202V15.625C8.75 15.9702 8.47018 16.25 8.125 16.25C7.77982 16.25 7.5 15.9702 7.5 15.625ZM10.1562 8.75C9.88933 9.61853 9.08106 10.25 8.125 10.25C7.96161 10.25 7.80271 10.2307 7.6499 10.1958L5.99658 13.061C6.64938 13.3429 7.36875 13.5 8.125 13.5C10.8821 13.5 13.1527 11.424 13.4624 8.75H10.1562ZM4.91357 3.81396C3.6002 4.79393 2.75 6.36031 2.75 8.125C2.75 9.88959 3.60033 11.4556 4.91357 12.4355L6.56738 9.56982C6.21549 9.19064 6 8.6831 6 8.125C6 7.56677 6.21535 7.0589 6.56738 6.67969L4.91357 3.81396ZM8.125 2.75C7.36882 2.75 6.64933 2.90666 5.99658 3.18848L7.6499 6.05371C7.80268 6.01881 7.96164 6 8.125 6C9.08106 6 9.88933 6.63147 10.1562 7.5H13.4624C13.1527 4.82601 10.8821 2.75 8.125 2.75ZM7.25 8.125C7.25 8.44547 7.42269 8.72501 7.67969 8.87744C7.68219 8.87884 7.68501 8.87991 7.6875 8.88135C7.69189 8.88388 7.69589 8.88702 7.7002 8.88965C7.82604 8.95971 7.97075 9 8.125 9C8.60825 9 9 8.60825 9 8.125C9 7.64175 8.60825 7.25 8.125 7.25C7.97388 7.25 7.83156 7.28803 7.70752 7.35547C7.70078 7.35971 7.69445 7.36464 7.6875 7.36865C7.68508 7.37005 7.68212 7.37071 7.67969 7.37207C7.42257 7.52447 7.25 7.80444 7.25 8.125Z" fill="#183649"/>
                        </svg>
                        <a href="#" onClick={this.handleBasisDialog}>
                            Læs grundlag for vedligeholdelsesplan her
                        </a>
                    </div>
                </Paper>
                <Paper className={`${classes.hidePrint} ${classes.paperWithoutHeight} ${classes.marginTop}`}>
                    <Typography className={classes.header} variant="h5">Sådan arbejder du med din vedligeholdelsesplan</Typography>
                    <iframe className={classes.iframe} width="700" height="394" src="https://www.youtube.com/embed/AMR-lYbXk08?si=fzvHfeUh7n6wrGNi" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
                <Contact
                    title="Ejendommens kontaktperson"
                    name={plan.contact_name}
                    email={plan.contact_email}
                    phone={plan.contact_phone}
                    src={plan.s3_image_id ? `https://ik.imagekit.io/aw3ddey5g/${plan.s3_image_id}?tr=w-200` : null}
                    variant="h5"
                    paperClasses={classes.paper}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <Contact
                    title="Rådgiver fra Plan1"
                    name={internal_contact.name}
                    email={internal_contact.email}
                    phone={internal_contact.phone}
                    src={internal_contact.s3_image_id ? `https://ik.imagekit.io/aw3ddey5g/${internal_contact.s3_image_id}?tr=w-200` : null}
                    variant="h5"
                    paperClasses={classes.paper}
                />
            </Grid>
            <Grid item sm={12} md={6}>
                <Paper className={`${classes.hidePrint} ${classes.paper}`}>
                    <Typography className={classes.header} variant="h5">Serviceaftale</Typography>
                    <Typography className={classes.serviceAgreement}>
                        {plan.purchased_inspection && plan.purchased_inspection === 1 ? 
                        <><Chip icon={<CheckCircleOutlineIcon className={classes.checkIcon}/>} label="Aktiv" className={classes.serviceChip}/><Typography component="div">
                        Opdateres næste gang: <b className={classes.serviceAgreementDate}>{plan.inspection_date ? moment().month(plan.inspection_date-1).format('MMMM') : null} <DateTime addYear={true} source={ plan.overridden_updated_at ? plan.overridden_updated_at : plan.updated_at } format="YYYY" /></b></Typography></> :
                        <Chip icon={<HighlightOffIcon className={classes.clearIcon}/>} label="Inaktiv" className={classes.serviceChipInactive}/>}
                    </Typography>
                    { plan.purchased_inspection && plan.purchased_inspection == 1 ? null : <Typography paragraph>{ texts.inspection
                    ? texts.inspection
                    : null
                    }</Typography>}
                </Paper>
            </Grid>
            <Grid item sm={12} md={6}>
                <Paper className={`${classes.hidePrint} ${classes.paper}`}>
                    <Typography className={classes.header} variant="h5">Noter</Typography>
                    <Typography variant="subtitle1" paragraph>
                        Se de seneste noter der er oprettet her. 
                    </Typography>
                    <ul className="list-unstyled">
                    { notesList }
                    </ul>
                </Paper>
            </Grid>
        </Grid>
        <Dialog onClose={this.handleBasisDialog} open={isBasisDialogOpen}>
            <DialogTitle onClose={this.handleBasisDialog}>
                Grundlag for drifts- og vedligeholdelsesplanen
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                  { texts.foundation
                    ? texts.foundation.split('\n').map((line, idx) => {
                      return (
                        <span key={ idx }>
                          { line }
                          <br />
                        </span>
                      )
                    })
                    : null
                  }
                </Typography>
            </DialogContent>
        </Dialog>
        <Dialog onClose={this.handleGuidanceDialog} open={isGuidanceDialogOpen}>
            <DialogTitle onClose={this.handleGuidanceDialog}>
                Vejledning
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    { texts.terms
                        ? texts.terms.split('\n').map((line, idx) => {
                        return (
                            <span key={ idx }>
                            { line }
                            <br />
                            </span>
                        )
                        })
                        : null
                    }
                </Typography>
            </DialogContent>
        </Dialog>
    </div>
    )
  }
}

const mapStateToProps = state => {
  const notes = state.data.customer.notes
  const uniqueNotes = uniqBy(notes, 'part_id')
  const keyedNotes = reduce(notes, (acc, note) => {
    const part_id = note.part_id
    let sum = acc[part_id] || {}
    sum.part_name = note.part_name
    sum.part_id = note.part_id
    sum.attachments = sum.attachments || []
    sum.attachments = note.attachments && note.attachments.length > 0
      ? sum.attachments.concat(note.attachments)
      : sum.attachments
    sum.count = sum.count + 1 || 1
    acc[part_id] = sum
    return acc
  }, {})
  const limitedNotes = uniqueNotes.splice(0, 16)
  return {
    readonly: state.data.customer.readonly,
    plan: state.data.customer.plan,
    notes: keyedNotes,
    texts: state.data.customer.systemTexts,
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch,
  setBreadcrumb: actions.setBreadcrumb,
  saveCustomerData: actions.saveCustomerData,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Dashboard))
